import { render } from "./NftScreenshot.vue?vue&type=template&id=3dbf6724&scoped=true"
import script from "./NftScreenshot.vue?vue&type=script&lang=js"
export * from "./NftScreenshot.vue?vue&type=script&lang=js"

import "./NftScreenshot.vue?vue&type=style&index=0&id=3dbf6724&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbf6724"]])

export default __exports__